import * as React from 'react';
import Slider, { Settings } from 'react-slick';

interface Props extends Settings {
	pushSlider: (slider: Slider) => void;
}

const CompareFaresSlider: React.FC<Props> = ({ children, pushSlider, ...props }) => {
	const sliderSettings: Settings = {
		...props,
		slidesToShow: 3
	};

	return (
		<Slider {...sliderSettings} ref={pushSlider}>
			{children}
		</Slider>
	);
};

export default CompareFaresSlider;
